import React, { useRef, useState } from 'react'
import { NoticeList } from './_components/noticeList'
import MenuInfo from '../menu/menuInfo'
import { MenuHeader } from '../menu/menuHeader'
import { useLocation } from 'react-router-dom'
import { SEO } from '@/components/seo/seo'
import { useResponsive } from '@/hooks/useResponsive'

const Notice: React.FC = () => {
  const location = useLocation()
  const menuInfoRef = useRef<HTMLDivElement | null>(null)
  const [hasMenuInfo, setHasMenuInfo] = useState<boolean>(true)
  const { isMobile, isTablet, isDesktop } = useResponsive()
  return (
    <>
      <SEO
        title="공지사항"
        //description="꿀프에서 골프 관련 서비스를 확인하세요."
        canonicalUrl="https://ggoollff.co.kr/notice"
      />
      <div style={{ padding: isMobile ? '0 16px' : '0' }}>
        <MenuHeader
          pathName={location.pathname}
          showWriteButton={false}
          menuInfoRef={menuInfoRef}
          loginRequired={false}
          iconActive={hasMenuInfo}
        />
      </div>
      <NoticeList />
      <div ref={menuInfoRef}>
        <MenuInfo menuPath={location.pathname} onDataCheck={setHasMenuInfo} />
      </div>
    </>
  )
}

export default Notice
